
import 'components/ckeditor.tag'
import 'components/loader.tag'
import 'pages/orders/orders-list-select-modal.tag'
import 'pages/persons/persons-list-select-modal.tag'
import moment from 'moment'
riot.tag2('payments-edit', '  <loader if="{loader}"></loader>\n  <virtual hide="{loader}">\n    <div class="btn-group"><a class="btn btn-default" href="#payments"><i class="fa fa-chevron-left"></i></a>\n      <button class="btn {item._edit_ ? &quot;btn-success&quot; : &quot;btn-default&quot;}" if="{isNew ? checkPermission(&quot;payments&quot;, &quot;0100&quot;) : checkPermission(&quot;payments&quot;, &quot;0010&quot;)}" onclick="{submit}"><i class="fa fa-floppy-o"></i> Сохранить</button>\n      <button class="btn btn-default" if="{!isNew}" onclick="{reload}" title="Обновить"><i class="fa fa-refresh"></i></button>\n    </div>\n    <div class="h4">{isNew ? \'Новый платёж\' : [\'Редактирование платежа:\', ⁗[#⁗ + item.id + ⁗]⁗].join(⁗ ⁗)}</div>\n    <form action="" onchange="{change}" onkeyup="{change}" method="POST">\n      <div class="row">\n        <div class="col-md-4">\n          <div class="form-group">\n            <label class="control-label">Назначение платежа</label>\n            <select class="form-control" name="paymentTarget" value="{item.paymentTarget}">\n              <option value="0">Оплата заказа</option>\n              <option value="1">Пополнение счёта</option>\n            </select>\n          </div>\n        </div>\n        <div class="col-md-4">\n          <div class="form-group">\n            <label class="control-label">Дата платежа</label>\n            <datetime-picker class="form-control" name="date" format="DD.MM.YYYY HH:mm" value="{item.dateDisplay}"></datetime-picker>\n          </div>\n        </div>\n        <div class="col-md-4">\n          <div class="form-group {has-error: error.amount}">\n            <label class="control-label">Сумма оплаты*</label>\n            <input class="form-control" name="amount" min="0" step="0.01" value="{parseFloat(item.amount)}" type="{\'number\'}">\n            <div class="help-block">{error.amount}</div>\n          </div>\n        </div>\n      </div>\n      <div class="row" if="{item.paymentTarget == 0}">\n        <div class="col-md-12">\n          <h4>Информация о заказе</h4>\n          <div class="row">\n            <div class="col-md-12">\n              <div class="form-group">\n                <label class="control-label">Заказ</label>\n                <div class="input-group">\n                  <input class="form-control" value="{item.idOrder ? &quot;Заказ № &quot; + item.idOrder + &quot; от &quot; + item.order.dateOrder + &quot; [&quot; + item.order.customer + &quot;]&quot; : &quot;&quot;}" __readonly="{true}">\n                  <div class="input-group-btn">\n                    <div class="btn btn-default" onclick="{selectOrder}"><i class="fa fa-list text-primary"></i></div>\n                  </div>\n                </div>\n              </div>\n            </div>\n          </div>\n          <div class="row" if="{item.idOrder}">\n            <div class="col-md-4">\n              <div class="form-group">\n                <label class="control-label">Сумма заказа</label>\n                <input class="form-control" value="{item.order.amount}" __readonly="{true}">\n              </div>\n            </div>\n            <div class="col-md-4">\n              <div class="form-group">\n                <label class="control-label">Оплачено</label>\n                <input class="form-control" value="{item.order.paid}" __readonly="{true}">\n              </div>\n            </div>\n            <div class="col-md-4">\n              <div class="form-group">\n                <label class="control-label">Доплата</label>\n                <input class="form-control" value="{item.order.surcharge}" __readonly="{true}">\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n      <div class="row">\n        <div class="col-md-12">\n          <h4>Информация о платеже</h4>\n          <div class="row">\n            <div class="col-md-8">\n              <div class="form-group">\n                <label class="control-label">Тип оплаты</label>\n                <select class="form-control" name="paymentType" value="{item.paymentType}">\n                  <option each="{paySystems}" value="{id}" __selected="{id == item.paymentType}" no-reorder>{name}</option>\n                </select>\n              </div>\n            </div>\n            <div class="col-md-4" if="{item.paymentType == 0}">\n              <div class="form-group">\n                <label class="control-label">Сумма на лицевом счёте</label>\n                <input class="form-control" value="{item.contact.balance}" __readonly="{true}">\n              </div>\n            </div>\n          </div>\n          <div class="row">\n            <div class="col-md-12">\n              <div class="form-group {has-error: (error.idAuthor || error.idCompany)}">\n                <label class="control-label">Плательщик*</label>\n                <div class="input-group">\n                  <input class="form-control" value="{item.payer}" __readonly="{true}">\n                  <div class="input-group-btn">\n                    <div class="btn btn-default" onclick="{selectPayer}"><i class="fa fa-list text-primary"></i></div>\n                  </div>\n                </div>\n                <div class="help-block">{(error.idAuthor || error.idCompany)}</div>\n              </div>\n            </div>\n          </div>\n          <div class="row">\n            <div class="col-md-12">\n              <div class="form-group">\n                <label class="control-label">Примечание</label>\n                <textarea class="form-control" rows="5" name="note" style="min-width: 100%; max-width: 100%;" value="{item.note}"></textarea>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n    </form>\n  </virtual>\n', '', '', function(opts) {
'use strict';

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var self = this;

self.isNew = false;

self.item = {};
self.paySystems = [];

self.mixin('validation');
self.mixin('permissions');
self.mixin('change');

self.rules = function () {
    var rules = {
        amount: ['empty', 'number']
    };

    if (self.item && (self.item.idAuthor || self.item.idCompany)) return (0, _extends3.default)({}, rules);else return (0, _extends3.default)({}, rules, { idAuthor: 'empty' });
};

self.afterChange = function (e) {
    var name = e.target.name;
    delete self.error[name];
    self.error = (0, _extends3.default)({}, self.error, self.validation.validate(self.item, self.rules(), name));
};

self.checkForSave = function () {
    if (!self.item.idOrder && !self.item.paymentTarget) {
        popups.create({
            title: 'Сохранение платежа!',
            text: 'Не выбран заказ!',
            style: 'popup-danger'
        });
        return false;
    }

    if (self.item.amount <= 0) {
        popups.create({
            title: 'Сохранение платежа!',
            text: 'Не указана сумма оплаты!',
            style: 'popup-danger'
        });
        return false;
    }

    if (self.item.paymentType == 0 && self.item.amount > self.item.contact.balance) {
        popups.create({
            title: 'Сохранение платежа!',
            text: 'Сумма платежа превышает сумму на лицевом счете плательщика!',
            style: 'popup-danger'
        });
        return false;
    }

    return true;
};

self.submit = function (e) {
    var params = self.item;
    if (!self.checkForSave()) return;

    self.error = self.validation.validate(self.item, self.rules());

    if (!self.error) {
        API.request({
            object: 'Payment',
            method: 'Save',
            data: params,
            success: function success(response) {
                popups.create({ title: 'Успех!', text: 'Платёж сохранен!', style: 'popup-success' });
                if (self.isNew) riot.route('payments/' + response.id);
                observable.trigger('payments-reload');
            }
        });
    }
};

self.reload = function () {
    self.item.id ? observable.trigger('payments-edit', self.item.id) : observable.trigger('payments-new');
};

function getOrderInfo(id) {
    var params = { id: id };

    API.request({
        object: 'Order',
        method: 'Info',
        data: params,
        success: function success(response, xhr) {
            self.item.order = response;
            self.item.amount = self.item.order.surcharge;
            self.update();
        }
    });
}

function getContactInfo(id) {
    var params = { id: id };

    API.request({
        object: 'Contact',
        method: 'Info',
        data: params,
        success: function success(response, xhr) {
            self.item.contact = response;
            self.update();
        }
    });
}

function getCompanyInfo(id) {
    var params = { id: id };

    API.request({
        object: 'Company',
        method: 'Info',
        data: params,
        success: function success(response, xhr) {
            self.item.contact = response;
            self.update();
        }
    });
}

function loadPaySystems() {
    var params = {};
    self.paySystems = [];
    API.request({
        object: 'PaySystem',
        method: 'Fetch',
        data: params,
        success: function success(response, xhr) {
            self.paySystems.push({ id: 0, name: "С лицевого счёта" });
            self.paySystems = self.paySystems.concat(response.items);
            self.update();
        }
    });
}

observable.on('payments-new', function () {
    self.error = false;
    self.isNew = true;
    self.item = {
        paymentTarget: 0,
        paymentType: 1,
        date: moment().format('DD.MM.YYYY HH:mm'),
        amount: 0
    };
    loadPaySystems();
    self.update();
});

observable.on('payments-edit', function (id) {
    var params = { id: id };
    self.error = false;
    self.loader = true;
    self.item = {};
    self.isNew = false;
    loadPaySystems();
    self.update();

    API.request({
        object: 'Payment',
        method: 'Info',
        data: params,
        success: function success(response, xhr) {
            self.item = response;
            self.loader = false;
            self.update();
        },
        error: function error(response) {
            self.item = {};
            self.loader = false;
            self.update();
        }
    });
});

self.selectOrder = function () {
    if (!self.isNew) return;
    modals.create('orders-list-select-modal', {
        type: 'modal-primary',
        submit: function submit() {
            var items = this.tags.catalog.tags.datatable.getSelectedRows();
            if (items.length) {
                self.item.idOrder = items[0].id;
                getOrderInfo(self.item.idOrder);

                if (items[0].idCompany) {
                    self.item.idCompany = items[0].idCompany;
                    self.item.idAuthor = null;
                    getCompanyInfo(self.item.idCompany);
                } else {
                    self.item.idAuthor = items[0].idAuthor;
                    self.item.idCompany = null;
                    getContactInfo(self.item.idAuthor);
                }

                self.item.payer = items[0].customer;

                self.update();
            }
            this.modalHide();
        }
    });
};

self.selectPayer = function () {
    modals.create('persons-company-list-modal', {
        type: 'modal-primary',
        size: 'modal-lg',
        submit: function submit() {
            var _this = this.tags['bs-modal'];
            var items = _this.tags[_this.tab].tags.datatable.getSelectedRows();
            if (!items.length) return;

            if (_this.tab == 'contacts') {
                self.item.idAuthor = items[0].id;
                self.item.payer = items[0].displayName;
                self.item.idCompany = null;
                getContactInfo(self.item.idAuthor);
            } else {
                self.item.idCompany = items[0].id;
                self.item.payer = items[0].name;
                self.item.idAuthor = null;
                getCompanyInfo(self.item.idCompany);
            }

            self.update();
            this.modalHide();
        }
    });
};

self.on('update', function () {
    localStorage.setItem('SE_section', 'shoppayment');
});

self.on('mount', function () {
    riot.route.exec();
});
});


// WEBPACK FOOTER //
// ./pages/payments/payments-edit.tag